import { __module as t } from "./chunk673.js";
import { __require as u } from "./chunk447.js";
import { __require as p } from "./chunk464.js";
var s = t.exports, c;
function x() {
  return c ? t.exports : (c = 1, function(n, d) {
    (function(r, e, o) {
      n.exports = e(u(), p());
    })(s, function(r) {
      return r.mode.ECB = function() {
        var e = r.lib.BlockCipherMode.extend();
        return e.Encryptor = e.extend({
          processBlock: function(o, i) {
            this._cipher.encryptBlock(o, i);
          }
        }), e.Decryptor = e.extend({
          processBlock: function(o, i) {
            this._cipher.decryptBlock(o, i);
          }
        }), e;
      }(), r.mode.ECB;
    });
  }(t), t.exports);
}
export {
  x as __require
};
